// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"36":"b46e65e5","280":"2fb54c77"}[chunkId] + ".chunk.js");